/**
 * AST 기반 자동 생성된 검증 함수
 * 이 파일은 scripts/generate-validators.ts에 의해 자동 생성됩니다.
 * 수동으로 수정하지 마세요.
 * 
 * 생성 시간: 2026-09-18T08:13:01.418Z
 * 소스 파일: src/data/dto/patient-treatement-detail-list/treatment-detail-reponse-dto
 */

import type { TreatmentDetailResponseDto } from "@/data/dto/patient-treatement-detail-list/treatment-detail-reponse-dto";

/**
 * TreatmentDetailResponseDto 타입 가드 함수
 * AST 분석을 통해 자동 생성된 최적화된 검증 함수
 */
export function isTreatmentDetailResponseDto(input: unknown): input is TreatmentDetailResponseDto {
  if (typeof input !== "object" || input === null || Array.isArray(input)) {
    return false;
  }
  
  const obj = input as Record<string, unknown>;
  
  return (
    typeof obj.treatmentInfo === "object" && obj.treatmentInfo !== null && !Array.isArray(obj.treatmentInfo) &&
typeof (obj.treatmentInfo as any).treatmentInfoUuid === "string" &&
((obj.treatmentInfo as any).step == null || (typeof (obj.treatmentInfo as any).step === "number" && !isNaN((obj.treatmentInfo as any).step))) &&
typeof (obj.treatmentInfo as any).state === "string" &&
typeof (obj.treatmentInfo as any).startDate === "string" &&
typeof (obj.treatmentInfo as any).endDate === "string" &&
typeof (obj.treatmentInfo as any).actuallyExecutedDay === "number" && !isNaN((obj.treatmentInfo as any).actuallyExecutedDay) &&
typeof (obj.treatmentInfo as any).recommendedExecutedDay === "number" && !isNaN((obj.treatmentInfo as any).recommendedExecutedDay) &&
typeof (obj.treatmentInfo as any).actuallyPlayTime === "number" && !isNaN((obj.treatmentInfo as any).actuallyPlayTime) &&
typeof (obj.treatmentInfo as any).recommendedTotalPlayTime === "number" && !isNaN((obj.treatmentInfo as any).recommendedTotalPlayTime) &&
typeof (obj.treatmentInfo as any).doctorName === "string" && (obj.treatmentInfo as any).doctorName.trim() !== "" &&
typeof (obj.treatmentInfo as any).memo === "string" &&
    typeof obj.activitiesByProgressDay === "object" && obj.activitiesByProgressDay !== null && !Array.isArray(obj.activitiesByProgressDay) &&
Object.entries(obj.activitiesByProgressDay).every(([key, value]) => {
  const numKey = Number(key);
  const val = value as any;
  return !isNaN(numKey) && typeof val === "object" && val !== null && !Array.isArray(val) &&
  ((val as any).uuid === undefined || ((val as any).uuid == null || typeof (val as any).uuid === "string")) &&
typeof (val as any).dateOfDay === "string" &&
  ((val as any).lightEstimationCount === undefined || typeof (val as any).lightEstimationCount === "number" && !isNaN((val as any).lightEstimationCount)) &&
  ((val as any).startTime === undefined || ((val as any).startTime == null || typeof (val as any).startTime === "string")) &&
  ((val as any).endTime === undefined || ((val as any).endTime == null || typeof (val as any).endTime === "string")) &&
  typeof (val as any).dailyProgress === "number" && !isNaN((val as any).dailyProgress) &&
  typeof (val as any).state === "number" && !isNaN((val as any).state);
})
  );
}

/**
 * TreatmentDetailResponseDto 상세 검증 결과 반환 함수
 * 검증 실패 시 상세한 에러 정보를 반환합니다.
 */
export interface IValidation<T> {
  success: boolean;
  data?: T;
  errors?: Array<{ path: string; expected: string; value: unknown }>;
}

export function validateTreatmentDetailResponseDto(input: unknown): IValidation<TreatmentDetailResponseDto> {
  const errors: Array<{ path: string; expected: string; value: unknown }> = [];
  
  if (typeof input !== "object" || input === null || Array.isArray(input)) {
    errors.push({
      path: "",
      expected: "object",
      value: input,
    });
    return {
      success: false,
      errors,
    };
  }
  
  const obj = input as Record<string, unknown>;
  
    if (typeof obj !== "object" || obj === null || Array.isArray(obj)) {
      errors.push({ path: "", expected: "object", value: obj });
    } else {
      const objObj = obj as Record<string, unknown>;
      // treatmentInfo (required)
      if (objObj.treatmentInfo === undefined) {
        errors.push({ path: "treatmentInfo", expected: "object", value: undefined });
      } else {
        if (typeof objObj.treatmentInfo !== "object" || objObj.treatmentInfo === null || Array.isArray(objObj.treatmentInfo)) {
          errors.push({ path: "treatmentInfo", expected: "object", value: objObj.treatmentInfo });
        } else {
          const objObj_treatmentInfoObj = objObj.treatmentInfo as Record<string, unknown>;
          // treatmentInfoUuid (required)
          if (objObj_treatmentInfoObj.treatmentInfoUuid === undefined) {
            errors.push({ path: "treatmentInfo.treatmentInfoUuid", expected: "string", value: undefined });
          } else {
            if (typeof objObj_treatmentInfoObj.treatmentInfoUuid !== "string") {
              errors.push({ path: "treatmentInfo.treatmentInfoUuid", expected: "string", value: objObj_treatmentInfoObj.treatmentInfoUuid });
            }
          }
          // step (required)
          if (objObj_treatmentInfoObj.step === undefined) {
            errors.push({ path: "treatmentInfo.step", expected: "number", value: undefined });
          } else {
            if (!(objObj_treatmentInfoObj.step == null || (typeof objObj_treatmentInfoObj.step === "number" && !isNaN(objObj_treatmentInfoObj.step)))) {
              errors.push({ path: "treatmentInfo.step", expected: "number | null", value: objObj_treatmentInfoObj.step });
            }
          }
          // state (required)
          if (objObj_treatmentInfoObj.state === undefined) {
            errors.push({ path: "treatmentInfo.state", expected: "string", value: undefined });
          } else {
            if (typeof objObj_treatmentInfoObj.state !== "string") {
              errors.push({ path: "treatmentInfo.state", expected: "string", value: objObj_treatmentInfoObj.state });
            }
          }
          // startDate (required)
          if (objObj_treatmentInfoObj.startDate === undefined) {
            errors.push({ path: "treatmentInfo.startDate", expected: "string", value: undefined });
          } else {
            if (typeof objObj_treatmentInfoObj.startDate !== "string") {
              errors.push({ path: "treatmentInfo.startDate", expected: "string", value: objObj_treatmentInfoObj.startDate });
            }
          }
          // endDate (required)
          if (objObj_treatmentInfoObj.endDate === undefined) {
            errors.push({ path: "treatmentInfo.endDate", expected: "string", value: undefined });
          } else {
            if (typeof objObj_treatmentInfoObj.endDate !== "string") {
              errors.push({ path: "treatmentInfo.endDate", expected: "string", value: objObj_treatmentInfoObj.endDate });
            }
          }
          // actuallyExecutedDay (required)
          if (objObj_treatmentInfoObj.actuallyExecutedDay === undefined) {
            errors.push({ path: "treatmentInfo.actuallyExecutedDay", expected: "number", value: undefined });
          } else {
            if (!(typeof objObj_treatmentInfoObj.actuallyExecutedDay === "number" && !isNaN(objObj_treatmentInfoObj.actuallyExecutedDay))) {
              errors.push({ path: "treatmentInfo.actuallyExecutedDay", expected: "number", value: objObj_treatmentInfoObj.actuallyExecutedDay });
            }
          }
          // recommendedExecutedDay (required)
          if (objObj_treatmentInfoObj.recommendedExecutedDay === undefined) {
            errors.push({ path: "treatmentInfo.recommendedExecutedDay", expected: "number", value: undefined });
          } else {
            if (!(typeof objObj_treatmentInfoObj.recommendedExecutedDay === "number" && !isNaN(objObj_treatmentInfoObj.recommendedExecutedDay))) {
              errors.push({ path: "treatmentInfo.recommendedExecutedDay", expected: "number", value: objObj_treatmentInfoObj.recommendedExecutedDay });
            }
          }
          // actuallyPlayTime (required)
          if (objObj_treatmentInfoObj.actuallyPlayTime === undefined) {
            errors.push({ path: "treatmentInfo.actuallyPlayTime", expected: "number", value: undefined });
          } else {
            if (!(typeof objObj_treatmentInfoObj.actuallyPlayTime === "number" && !isNaN(objObj_treatmentInfoObj.actuallyPlayTime))) {
              errors.push({ path: "treatmentInfo.actuallyPlayTime", expected: "number", value: objObj_treatmentInfoObj.actuallyPlayTime });
            }
          }
          // recommendedTotalPlayTime (required)
          if (objObj_treatmentInfoObj.recommendedTotalPlayTime === undefined) {
            errors.push({ path: "treatmentInfo.recommendedTotalPlayTime", expected: "number", value: undefined });
          } else {
            if (!(typeof objObj_treatmentInfoObj.recommendedTotalPlayTime === "number" && !isNaN(objObj_treatmentInfoObj.recommendedTotalPlayTime))) {
              errors.push({ path: "treatmentInfo.recommendedTotalPlayTime", expected: "number", value: objObj_treatmentInfoObj.recommendedTotalPlayTime });
            }
          }
          // doctorName (required)
          if (objObj_treatmentInfoObj.doctorName === undefined) {
            errors.push({ path: "treatmentInfo.doctorName", expected: "string", value: undefined });
          } else {
            if (!(typeof objObj_treatmentInfoObj.doctorName === "string" && objObj_treatmentInfoObj.doctorName.trim() !== "")) {
              errors.push({ path: "treatmentInfo.doctorName", expected: "string (non-empty)", value: objObj_treatmentInfoObj.doctorName });
            }
          }
          // memo (required)
          if (objObj_treatmentInfoObj.memo === undefined) {
            errors.push({ path: "treatmentInfo.memo", expected: "string", value: undefined });
          } else {
            if (typeof objObj_treatmentInfoObj.memo !== "string") {
              errors.push({ path: "treatmentInfo.memo", expected: "string", value: objObj_treatmentInfoObj.memo });
            }
          }
        }
      }
      // activitiesByProgressDay (required)
      if (objObj.activitiesByProgressDay === undefined) {
        errors.push({ path: "activitiesByProgressDay", expected: "indexSignature", value: undefined });
      } else {
        // 인덱스 시그니처 검증
        if (typeof objObj.activitiesByProgressDay === "object" && objObj.activitiesByProgressDay !== null && !Array.isArray(objObj.activitiesByProgressDay)) {
          Object.entries(objObj.activitiesByProgressDay).forEach(([key, value]) => {
            const numKey = Number(key);
            const val = value as any;
            if (isNaN(numKey)) {
              errors.push({ path: "activitiesByProgressDay[key]", expected: "number key", value: key });
            } else {
              if (typeof val !== "object" || val === null || Array.isArray(val)) {
                errors.push({ path: "activitiesByProgressDay[key]", expected: "object", value: val });
              } else {
                const valObj = val as Record<string, unknown>;
                // uuid (optional)
                if (valObj.uuid !== undefined) {
                  if (!(valObj.uuid == null || typeof valObj.uuid === "string")) {
                    errors.push({ path: "activitiesByProgressDay[key].uuid", expected: "string | null", value: valObj.uuid });
                  }
                }
                // dateOfDay (required)
                if (valObj.dateOfDay === undefined) {
                  errors.push({ path: "activitiesByProgressDay[key].dateOfDay", expected: "string", value: undefined });
                } else {
                  if (typeof valObj.dateOfDay !== "string") {
                    errors.push({ path: "activitiesByProgressDay[key].dateOfDay", expected: "string", value: valObj.dateOfDay });
                  }
                }
                // lightEstimationCount (optional)
                if (valObj.lightEstimationCount !== undefined) {
                  if (!(typeof valObj.lightEstimationCount === "number" && !isNaN(valObj.lightEstimationCount))) {
                    errors.push({ path: "activitiesByProgressDay[key].lightEstimationCount", expected: "number", value: valObj.lightEstimationCount });
                  }
                }
                // startTime (optional)
                if (valObj.startTime !== undefined) {
                  if (!(valObj.startTime == null || typeof valObj.startTime === "string")) {
                    errors.push({ path: "activitiesByProgressDay[key].startTime", expected: "string | null", value: valObj.startTime });
                  }
                }
                // endTime (optional)
                if (valObj.endTime !== undefined) {
                  if (!(valObj.endTime == null || typeof valObj.endTime === "string")) {
                    errors.push({ path: "activitiesByProgressDay[key].endTime", expected: "string | null", value: valObj.endTime });
                  }
                }
                // dailyProgress (required)
                if (valObj.dailyProgress === undefined) {
                  errors.push({ path: "activitiesByProgressDay[key].dailyProgress", expected: "number", value: undefined });
                } else {
                  if (!(typeof valObj.dailyProgress === "number" && !isNaN(valObj.dailyProgress))) {
                    errors.push({ path: "activitiesByProgressDay[key].dailyProgress", expected: "number", value: valObj.dailyProgress });
                  }
                }
                // state (required)
                if (valObj.state === undefined) {
                  errors.push({ path: "activitiesByProgressDay[key].state", expected: "number", value: undefined });
                } else {
                  if (!(typeof valObj.state === "number" && !isNaN(valObj.state))) {
                    errors.push({ path: "activitiesByProgressDay[key].state", expected: "number", value: valObj.state });
                  }
                }
              }
            }
          });
        } else {
          errors.push({ path: "activitiesByProgressDay", expected: "indexSignature object", value: objObj.activitiesByProgressDay });
        }
      }
    }
  
  if (errors.length === 0 && isTreatmentDetailResponseDto(input)) {
    return {
      success: true,
      data: input,
    };
  }
  
  return {
    success: false,
    errors: errors.length > 0 ? errors : [
      {
        path: "",
        expected: "TreatmentDetailResponseDto",
        value: input,
      },
    ],
  };
}

/**
 * TreatmentDetailResponseDto 검증 후 에러 throw 함수
 * 검증 실패 시 상세한 에러 정보를 포함하여 에러를 throw합니다.
 */
export function assertTreatmentDetailResponseDto(input: unknown): TreatmentDetailResponseDto {
  const validation = validateTreatmentDetailResponseDto(input);
  if (!validation.success) {
    const errorDetails = validation.errors?.map(err => 
      `  - ${err.path}: 예상 타입 ${err.expected}, 실제 값: ${JSON.stringify(err.value)}`
    ).join("\n") || "알 수 없는 오류";
    throw new Error(`[assertTreatmentDetailResponseDto] :: 검증 실패: TreatmentDetailResponseDto 타입과 일치하지 않습니다\n\n오류 상세:\n${errorDetails}`);
  }
  return validation.data!;
}
